import React from 'react';
import {
  footerHeadFontBoldStyle,
  footerHeadFontStyle
} from '../../partnerStyles';
import FlexListComponent from '../FlexListComponent';
import { bindActionCreators } from 'redux';
import * as GlobalActions from '../../reducers/actions';
import { connect } from 'react-redux';

const FooterNearbyPlaces = props => {
  return (
    <div>
      <div style={footerHeadFontBoldStyle}>
        {props.globalData.universal_translations.nearby_hotel_heading}
      </div>

      <FlexListComponent
        list={[
          [
            'Hotels near Atlanta',
            'Hotels near Atlanta',
            'Hotels near Delhi',
            'Hotels near Pak'
          ],
          ['Hotels near Thai', 'Hotels near Dargan', 'Hotels near Jaipur'],
          [
            'Hotels near Gandhinagar',
            'Hotels near Poland',
            'Hotels near Atlanta'
          ],
          ['Hotels near Sim', 'Hotels near Shimla', 'Hotels near Drexen'],
          ['Hotels near Bangla', 'Hotels near Yvelte', 'Hotels near Garan'],
          ['Hotels near Atlanta', 'Hotels near Atlanta']
        ]}
        divStyle={{ width: '100%', marginTop: '30px', marginBottom: '30px' }}
        uniformWidths={true}
        text_style={footerHeadFontStyle}
      />
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FooterNearbyPlaces);
